const ua = navigator.userAgent.toLowerCase()

const names = {
  chrome: 'Chrome',
  safari: 'Safari',
  opera: 'Opera',
  firefox: 'FireFox',
  msie: 'IE'
}

const chrome = /chrome/i.test(ua)
const safari = !chrome && /safari/.test(ua)
const opera = /opera/.test(ua)
const firefox = /firefox/.test(ua)
const msie = !opera && !firefox && /msie|rv:/.test(ua)
const version = (ua.match(/.+(?:rv|it|ra|ie)[/: ]([\d.]+)/) || [])[1]

const engine = {
  chrome,
  safari,
  opera,
  firefox,
  msie
}

export default function (Vue) {
  for (let k in engine) {
    if (engine.hasOwnProperty(k) && engine[k]) {
      engine.name = names[k]
      break
    }
  }

  engine.name = engine.name || 'unknown'
  engine.version = version || 0

  Vue.browser = engine

  Vue.mixin({
    created () {
      this.$browser = engine
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/browser.js